module.exports = __webpack_public_path__ + "media/images/lp-thinking-lady@2x-39edbaa2f3e391b06bf6002b354b06df.png";